import {Theme} from '../../theme/Theme';

const {colours} = Theme;

export const SectionColours = {
  DEFAULT: [colours.yellow, colours.orange],
  ALTERNATE: [colours.blue, colours.red],
};
